module.exports = __webpack_public_path__ + "img/image_5.3317c509.jpg";